import React from 'react'
import { makeStyles } from '@material-ui/core'

const DividerWithText = ({ children, width = '100%' }) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      width: width,
    },
    border: {
      borderBottom: '1px solid lightgray',
      width: '100%',
    },
    content: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      fontWeight: 400,
      fontSize: 16,
      color: 'lightgray',
    },
  }))
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.border} />
      <span className={classes.content}>{children}</span>
      <div className={classes.border} />
    </div>
  )
}
export default DividerWithText
